import { Quasar, Notify, Loading } from 'quasar';
import 'quasar/src/css/index.sass';
import '../css/quasar-reset.css';

export function initQuasar(app: any): void {
  app.use(Quasar, {
    plugins: {
      Notify,
      Loading,
    }, // e.g. Notify, Dialog, etc.
    config: {
      cssAddon: false, // Disable global CSS styles for h1-h6, hr, etc.
    },
  });
}
